import { Routes, Route, useLocation } from 'react-router-dom';
import { TransitionProvider, useTransition } from './hooks/useTransition';
import CanvasScene from './components/CanvasScene';
import LandingOverlay from './components/ui/LandingOverlay';
import TransitionOverlay from './components/ui/TransitionOverlay';
import ProjectsPage from './pages/ProjectsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

function AppContent() {
  const location = useLocation();
  const { isTransitioning } = useTransition();
  const isLanding = location.pathname === '/';

  return (
    <>
      <div style={{ display: isLanding ? 'block' : 'none' }}>
        <CanvasScene />
      </div>

      {isLanding && <LandingOverlay />}

      <Routes>
        <Route path="/" element={null} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>

      <TransitionOverlay active={isTransitioning} />
    </>
  );
}

export default function App() {
  return (
    <TransitionProvider>
      <AppContent />
    </TransitionProvider>
  );
}
